module.exports = __webpack_public_path__ + "static/media/3_graph2.cbcd9eff.svg";